import { APP_URLS } from '../../consts';
import { AvailableBrands, BRANDS } from '../../components/Itv/types';
import { GameType } from '../../components/Games/games.model';

const SUPPORTED_ITV_BRANDS: AvailableBrands[] = [BRANDS.BINGO, BRANDS.SPINS];

const isSupportedItvBrand = (value: string | undefined): value is BRANDS => {
  return Boolean(value && SUPPORTED_ITV_BRANDS.includes(value as AvailableBrands));
};

export const buildItvGameDetailsBasePath = (brand: BRANDS, gameType?: GameType): string => {
  if (gameType === GameType.Bingo) {
    return `/${brand}/bingo-details`;
  }

  return `/${brand}/game-details`;
};

export const resolveGameDetailsBasePath = (
  brandSegment: AvailableBrands | null,
  gameType?: GameType
): {
  basePath: string;
  brand: BRANDS | null;
} => {
  brandSegment = brandSegment || 'spins';

  if (isSupportedItvBrand(brandSegment)) {
    return {
      basePath: buildItvGameDetailsBasePath(brandSegment, gameType),
      brand: brandSegment,
    };
  }

  return {
    basePath: gameType === GameType.Bingo ? APP_URLS.itv.bingoDetailsBase : APP_URLS.itv.gameDetailsBase,
    brand: null,
  };
};

export type GameDetailsBasePathResult = ReturnType<typeof resolveGameDetailsBasePath>;
